export const WorkOrderStatus = {
    SUCCESS: 'success',
    FAIL: 'fail',
    START : ''
};